import { useState } from "react";
import Modal from "../../components/common/Modal";
import CrudForm from "../../components/common/crud/CrudForm";
import apiClient from "../../services/apiClient";
import alertService from "../../utils/alertService";
import { normalizeApiError } from "../../utils/apiError";

const expenseCategoryFormSchema = [
  {
    name: "categoryName",
    label: "Category Name",
    type: "text",
    placeholder: "e.g. Travel, Office Supplies",
    validation: {
      required: true,
      minLength: 2,
      maxLength: 100,
    },
  },
  {
    name: "isActive",
    label: "Active",
    type: "checkbox",
    defaultValue: true,
  },
];

function ExpenseCategoryCreateModal({ isOpen, onClose, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await apiClient.post("/expense-category", values);
      alertService.success("Expense Category created successfully.");
      onSuccess?.();
      onClose();
    } catch (err) {
      alertService.error(normalizeApiError(err).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add New Expense Category">
      <CrudForm
        mode="create"
        schema={expenseCategoryFormSchema}
        initialValues={{ isActive: true }}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}

export default ExpenseCategoryCreateModal;
